import {Action, Catalog} from '../../../../common/types/common';

export const LOSE_APPLICATION_ACTION: Action = {
    name: 'LOSE_APPLICATION_ACTION',
    action: (reason: Catalog, isForce: boolean) => ({
        reason, isForce,
        type: LOSE_APPLICATION_ACTION.name
    })
};

export const REOPEN_APPLICATION_ACTION: Action = {
    name: 'REOPEN_APPLICATION_ACTION',
    action: () => ({
        type: REOPEN_APPLICATION_ACTION.name
    })
};
